import { cx } from '@linaria/core';

export const TeaserMainContentArea = ({ className, children }) => (
  <div className={cx(className, 'teaser-data-wrap col-12')} >
    {children}
  </div>
);

export const StyledTeaserMainContentArea = TeaserMainContentArea;
